import http from 'axios'
import config from 'src/config'

export const getEntries = ({ contentType }) => (dispatch, getState) => {
  if (!getState().cms[contentType]) {
    return dispatch({
      type: 'CMS/GET_ENTRIES',
      payload: http({
        method: 'GET',
        url: `${config.other.contentfulUrl}/spaces/${config.other.contentfulSpaceId}/entries`,
        headers: {
          Authorization: null,
        },
        params: {
          access_token: config.other.contentfulToken,
          content_type: contentType,
          include: 3,
        },
      }),
      meta: {
        contentType,
      },
    })
  }
  return new Promise(resolve => resolve())
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Cms.actions.js